import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '../features/dashboard/Dashboard';
import { Chat } from '../features/chat';
import FirmDocumentsPage from '../features/documents/FirmDocumentsPage';
import BankStatements from '../features/upload/components/BankStatements';
import LegalActsPage from '../features/legal-acts/LegalActsPage';
import CaseLawPage from '../features/case-law/CaseLawPage';
import DoctrinePage from '../features/doctrine/DoctrinePage';
import PoliciesPage from '../features/policies/PoliciesPage';
import { Settings } from '../features/settings';

// Every page is open to every member of a firm: what each role may do there
// (upload, edit, manage) is decided by the server and shown by the page
// itself (RequireRole / useAuth flags). The settings tabs limit themselves.
export const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Dashboard />} />
    <Route path="/chat" element={<Chat />} />
    <Route path="/documents" element={<FirmDocumentsPage />} />
    <Route path="/bank-statements" element={<BankStatements />} />
    <Route path="/legal-acts" element={<LegalActsPage />} />
    <Route path="/case-law" element={<CaseLawPage />} />
    <Route path="/doctrine" element={<DoctrinePage />} />
    <Route path="/policies" element={<PoliciesPage />} />
    <Route path="/settings" element={<Settings />} />

    {/* Old bookmarks from NaDiA's previous release */}
    <Route path="/upload-regulations" element={<Navigate to="/legal-acts?jurisdiction=CH" replace />} />
    <Route path="/regional-documents" element={<Navigate to="/legal-acts?jurisdiction=TI" replace />} />
    <Route path="/cantonal-jurisprudence" element={<Navigate to="/case-law" replace />} />
    <Route path="/contributi-dottrinali" element={<Navigate to="/doctrine" replace />} />
    <Route path="/procedural-guidelines" element={<Navigate to="/policies" replace />} />
    <Route path="/requests" element={<Navigate to="/" replace />} />
    <Route path="/upload-requests" element={<Navigate to="/" replace />} />
    <Route path="/office-data" element={<Navigate to="/" replace />} />
    <Route path="/unauthorized" element={<Navigate to="/" replace />} />
    <Route path="/chat-enhanced" element={<Navigate to="/chat" replace />} />

    {/* Catch-all: any other unknown path (including now-removed old routes) lands on the dashboard */}
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default AppRoutes;
